module.exports = "<div [style.text-align]=\"textAlignment\" [style.margin]=\"margin\" class=\"title\" [attr.data-e2e]='e2eTag'>\n\t{{ title }}\n</div>\n"